import React from 'react';
import { Formik } from 'formik';
import {
  getUpdatedVendorValues,
  getVendorInitialValues,
  vendorInitialValues,
  vendorValidationSchema,
} from 'pages/Vendor/constants';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { useMutation } from '@apollo/client';
import { CREATE_TRADER, UPDATE_TRADER } from 'pages/Vendor/VendorGraphQL';
import { toast } from 'react-toastify';
import {
  RECORD_ADDED_SUCCESSFULLY,
  RECORD_UPDATED_SUCCESSFULLY,
} from 'components/common/FSBToastify/types';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import AddVendorForm from './components/AddVendorForm';

const AddVendor = ({ drawerToggle, type, value }) => {
  const [createTrader] = useMutation(CREATE_TRADER, {
    onCompleted: () => {
      toast.success(RECORD_ADDED_SUCCESSFULLY);
      drawerToggle('', ADD_EDIT_CONSTANT.ADD);
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
        drawerToggle('', ADD_EDIT_CONSTANT.ADD);
      });
    },
  });
  const [updateTrader] = useMutation(UPDATE_TRADER, {
    onCompleted: () => {
      toast.success(RECORD_UPDATED_SUCCESSFULLY);
      drawerToggle('', ADD_EDIT_CONSTANT.ADD);
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
        drawerToggle('', ADD_EDIT_CONSTANT.ADD);
      });
    },
  });
  const handleSubmit = async (values) => {
    if (type === ADD_EDIT_CONSTANT.ADD) {
      try {
        await createTrader({
          variables: {
            trader: {
              ...values,
              // isKycVerified: values.isKycVerified.id,
              callingCode: values.callingCode?.id,
              addresses: values.addresses
                .filter((item) => 
                  (item.street && item.street.trim() !== '') || 
                  (item.pinCode && String(item.pinCode).trim() !== '') || 
                  item.city || item.state || item.country
                )
                .map((item) => {
                  return {
                    city: item?.city?.id,
                    state: item?.state?.id,
                    country: item?.country?.id,
                    street: item?.street,
                    pinCode: item?.pinCode,
                  };
                }),
            },
          },
        });
      } catch {}
    } else if (type === ADD_EDIT_CONSTANT.EDIT) {
      try {
        await updateTrader({
          variables: { trader: getUpdatedVendorValues(values) },
        });
      } catch {}
    }
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          enableReinitialize
          validationSchema={vendorValidationSchema}
          initialValues={
            type === ADD_EDIT_CONSTANT.ADD
              ? vendorInitialValues
              : getVendorInitialValues(value)
          }
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <AddVendorForm
                {...props}
                type={type}
                drawerToggle={drawerToggle}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AddVendor;
